import Vue from "vue";
// import VueI18n from "vue-i18n";

import App from "./App.vue";
// const axios = () => import(/* webpackChunkName: "axios" */ "axios");
import axios from "axios";
import store from "./store";
import router from "./router";
import i18n from "./i18n";


// const {library} = () => import(/* webpackChunkName: "fasvg" */ "@fortawesome/fontawesome-svg-core");
import(/* webpackChunkName: "JoditVue" */ "jodit/build/jodit.min.css");

//ALT FONTAWESOME
// import '@fortawesome/fontawesome-free/css/all.min.css'
// import '@fortawesome/fontawesome-free/js/all.js'

// // BEGIN: FONTAWESOME IMPORT
// import { library } from "@fortawesome/fontawesome-svg-core";
// import {
//   faUserSecret,
//   faCheck,
//   faCheckCircle,
//   faInfoCircle,
//   faExclamationTriangle,
//   faExclamationCircle,
//   faArrowUp,
//   faArrowDown,
//   faArrowLeft,
//   faArrowRight,
//   faAngleUp,
//   faAngleDown,
//   faAngleLeft,
//   faAngleRight,
//   faChevronUp,
//   faChevronDown,
//   faChevronLeft,
//   faChevronRight,
//   faEye,
//   faEyeSlash,
//   faCaretDown,
//   faCaretUp,
//   faTrash,
//   faUpload,
//   faSync,
//   faSyncAlt,
//   faSpinner,
//   faSave,
//   faPlus,
//   faMinus,
//   faEdit,
//   faEllipsisV,
//   faEllipsisH,
//   faTimes,
//   faPlay,
//   faBars,
//   faStop,
//   faFilePdf,
//   faForward,
//   faBackward,
//   faEraser,
//   faCalendar,
//   faClock,
//   faBroadcastTower,
//   faTv,
//   faBook,
//   faLanguage,
//   faImage,
//   faFilm,
//   faPhotoVideo,
//   faTag,
//   faHourglassHalf,
//   faDownload,
//   faEnvelope,
//   faEnvelopeOpen,
//   faRedo,
//   faQuestion,
//   faHome,
//   faNewspaper,
//   faGlobe,
//   faSignInAlt,
//   faSignOutAlt,
//   faTools,
//   faComment,
//   faComments,
//   faFolder,
//   faFolderOpen,
//   faStar,
//   faList
// } from "@fortawesome/free-solid-svg-icons";
//
// import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";

// import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";

// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import { fas } from "@fortawesome/free-solid-svg-icons";
// import { far } from "@fortawesome/free-regular-svg-icons";
// import { fab } from ‘@fortawesome/free-brands-svg-icons’;

// library.add(fas);
// library.add(far);

// Vue.component("vue-fontawesome", FontAwesomeIcon);
// Vue.component('font-awesome-icon', FontAwesomeIcon);


// library.add(
//   faUserSecret,
//   faCheck,
//   faCheckSquare,
//   faCheckCircle,
//   faInfoCircle,
//   faExclamationTriangle,
//   faExclamationCircle,
//   faArrowUp,
//   faArrowDown,
//   faArrowLeft,
//   faArrowRight,
//   faAngleUp,
//   faAngleDown,
//   faAngleLeft,
//   faAngleRight,
//   faChevronUp,
//   faChevronDown,
//   faChevronLeft,
//   faChevronRight,
//   faEye,
//   faEyeSlash,
//   faCaretDown,
//   faCaretUp,
//   faTrash,
//   faUpload,
//   faSync,
//   faSyncAlt,
//   faSpinner,
//   faSave,
//   faPlus,
//   faMinus,
//   faEdit,
//   faEllipsisV,
//   faEllipsisH,
//   faTimes,
//   faPlay,
//   faStop,
//   faBars,
//   faFilePdf,
//   faSquare,
//   faForward,
//   faBackward,
//   faEraser,
//   faCalendar,
//   faClock,
//   faBroadcastTower,
//   faTv,
//   faBook,
//   faLanguage,
//   faImage,
//   faFilm,
//   faPhotoVideo,
//   faTag,
//   faHourglassHalf,
//   faDownload,
//   faEnvelope,
//   faEnvelopeOpen,
//   faRedo,
//   faQuestion,
//   faHome,
//   faNewspaper,
//   faGlobe,
//   faSignInAlt,
//   faSignOutAlt,
//   faTools,
//   faComment,
//   faComments,
//   faFolder,
//   faFolderOpen,
//   faStar,
//   faList
// );
// Vue.component("vue-fontawesome", FontAwesomeIcon);
// //END: FONT AWESOME IMPORT

//BEGIN: buefy full
import Buefy from "buefy";
// import "buefy/dist/buefy.css";
Vue.use(Buefy, {
  // defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
});
//END: buefy full

// import MyBuefy from "./MyBuefy";
// Vue.use(MyBuefy);

import IgCard from "@/components/IgCard";
Vue.use(IgCard);
Vue.component('ig-card',IgCard);

import IgModal from "@/components/IgModal";
Vue.use(IgModal);
Vue.component('ig-modal',IgModal);

import IgButton from "@/components/IgButton";
Vue.use(IgButton);
Vue.component('ig-button',IgButton);

import GNumInput from "@/components/GNumInput";
Vue.use(GNumInput);
Vue.component('g-numinput',GNumInput);

//BEGIN: flatpickr (datetime picker)
// const FlatPickr = () => import(/* webpackChunkName: "flatpkr" */ "vue-flatpickr-component");
// import(/* webpackChunkName: "flatpkr" */ "flatpickr/dist/flatpickr.min.css");
// import FlatPickr from "vue-flatpickr-component";
// Vue.use(FlatPickr);
//END: flatpickr

//BEGIN: DStd
import DStd from "@/DStd.js";
Object.defineProperty(Vue.prototype, "$dstd", { value: DStd });
//END: DStd

import Api from "@/services/Api";
Object.defineProperty(Vue.prototype, "$api1", { value: Api });

//jodit (text wysiwyeditor)
// import "jodit/build/jodit.min.css";

// import Hero from "./components/Hero.vue";
// import DPagination from "./components/DPagination.vue";
// import DVideo from "./components/DVideo.vue";
// Vue.use(Hero);
// Vue.component("d-pagination", DPagination);
// Vue.component("d-video", DVideo);

// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// Vue.component("vue-fontawesome", FontAwesomeIcon);
// import(/* webpackChunkName: "MyIcons" */ "./MyIcons");

Vue.prototype.$http = axios;
Vue.config.productionTip = true;
Vue.prototype.igapp = { ver: "2.1.11" };



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
